/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_No_Terms_To_ExportInputs */



/**
* | output |
* | --- |
* | "No terms to export" |
*
* @param {Knp_Terms_No_Terms_To_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_no_terms_to_export = /** @type {((inputs?: Knp_Terms_No_Terms_To_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_No_Terms_To_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun terme à exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Exportbedingungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun termine da esportare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Условия для экспорта отсутствуют.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay condiciones para exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有出口条款")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートする用語はありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात के लिए कोई शर्तें नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há termos para exportar.")
	return /** @type {LocalizedString} */ ("No terms to export")
});